import { createContext } from 'react';

export type SidebarContextProps = {
  isSidebarActive: boolean;
  isSidebarAnchored: boolean;
  setIsSidebarActive: (value: boolean) => void;
  setIsSidebarAnchored: (value: boolean) => void;
};

export const SidebarContext = createContext<SidebarContextProps>({
  isSidebarActive: false,
  isSidebarAnchored: false,
  setIsSidebarActive: () => {},
  setIsSidebarAnchored: () => {},
});
